import ComunicaEngine from './ComunicaEngine';
export default ComunicaEngine;
